import type { GridFilterItem } from '@mui/x-data-grid'
import { create } from 'zustand'

export type GridFilterItemWithId = GridFilterItem & { id: string }

interface FilterState {
  // tableId -> filters
  filters: Record<string, GridFilterItemWithId[]>
}

interface FilterActions {
  setFilters: (tableId: string, items: GridFilterItemWithId[]) => void
  clearFilters: (tableId: string) => void
}

type FilterStore = FilterState & FilterActions

export const useFilterStore = create<FilterStore>(set => ({
  filters: {},

  setFilters: (tableId: string, items: GridFilterItemWithId[]) =>
    set(state => ({
      filters: { ...state.filters, [tableId]: items }
    })),

  clearFilters: (tableId: string) =>
    set(state => ({
      filters: { ...state.filters, [tableId]: [] }
    }))
}))
